import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const pushnotification = {
  getData,
  storeOrUpdate,
  markRead,
  markAllRead,
  dismiss,
  getUnreadCount,
};

/**
 * Get notifications for the authenticated user on a property
 * Backend uses JWT identity - no need to pass user_id
 */
function getData(propertyId) {
  return axios
    .get(
      `${apiEndpoint.pushnotification}?property_id=${propertyId}`,
      {
        headers: authHeader(),
      }
    )
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { notification: [], code: res.data?.code || 'error' };
    })
    .catch(err => {
      console.error('Error fetching notifications:', err);
      return { notification: [], code: 'error' };
    });
}

/**
 * Create or update a notification
 */
function storeOrUpdate(data, id = null) {
  return (id ? (
    axios.put(
      apiEndpointFunction.pushnotification(id),
      data,
      {
        headers: authHeader(),
      }
    )
  ) : (
    axios.post(
      apiEndpoint.pushnotification,
      data,
      {
        headers: authHeader()
      }
    )
  )).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

/**
 * Mark a single notification as read
 * Backend uses JWT identity - no need to pass user_id
 */
function markRead(notificationId) {
  return axios
    .post(
      `${apiEndpoint.pushnotification}/${notificationId}/mark-read`,
      {},
      {
        headers: authHeader()
      }
    )
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch(err => {
      console.error('Error marking notification as read:', err);
      return {};
    });
}

/**
 * Mark all notifications as read for the authenticated user on a property
 * Backend uses JWT identity - no need to pass user_id
 */
function markAllRead(propertyId) {
  return axios
    .post(
      `${apiEndpoint.pushnotification}/mark-all-read`,
      {
        property_id: propertyId,
      },
      {
        headers: authHeader()
      }
    )
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch(err => {
      console.error('Error marking all notifications as read:', err);
      return {};
    });
}

/**
 * Dismiss (soft delete) a notification for the authenticated user
 * Backend uses JWT identity - no need to pass user_id
 */
function dismiss(notificationId) {
  return axios
    .post(
      `${apiEndpoint.pushnotification}/${notificationId}/dismiss`,
      {},
      {
        headers: authHeader()
      }
    )
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch(err => {
      console.error('Error dismissing notification:', err);
      return {};
    });
}

/**
 * Get unread notification count for the authenticated user on a property
 * Backend uses JWT identity - no need to pass user_id
 */
function getUnreadCount(propertyId) {
  return axios
    .get(
      `${apiEndpoint.pushnotification}/unread-count?property_id=${propertyId}`,
      {
        headers: authHeader(),
      }
    )
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data.unread_count || 0;
      }
      return 0;
    })
    .catch(err => {
      console.error('Error fetching unread count:', err);
      return 0;
    });
}
